/* eslint-disable prefer-destructuring */
/* eslint-disable max-len */
// eslint-disable-next-line no-undef
let $globalConfig;
if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    $globalConfig = config;
}

const overlayConfig = {
    selectors: {
        searchForm: '.catalog__search',
        searchInput: '.catalog__search-input-overlay',
        searchOverlay: '#catalog-search-overlay',
        searchWordsContainer: '.catalog-search-overlay__searchwords-container',
        searchAreasContainer: '.catalog-search-overlay__areas-container',
        searchProductsContainer: '.catalog-search-overlay__products-container',
        closeButton: '.catalog-search-overlay__close-button',
        searchProductsAndAreasContainer: '.catalog-search-overlay__container-areasandproducts',
        searchSearchwordsContainer: '.catalog-search-overlay__container-searchwords',
        searchWordsContainerMain: '.catalog-search-overlay__searchwords',
        searchAreasContainerMain: '.catalog-search-overlay__areas',
        searchProductsContainerMain: '.catalog-search-overlay__products',
        searchWordItem: 'catalog-search-overlay__searchword',
        productItem: 'catalog-search-overlay__product-text-container',
        areaItem: 'catalog-search-overlay__area-link',
    },
    classNames: {
        searchOverlayActive: 'catalog-search-overlay--visible',
        searchContainerActive: 'catalog-search-overlay__container--visible',
        searchContainerFullWidth: 'catalog-search-overlay__container--full-width',
        searchWordsContainerMainActive: 'catalog-search-overlay__searchwords--visible',
        searchAreasContainerMainActive: 'catalog-search-overlay__areas--visible',
        searchProductsContainerMainActive: 'catalog-search-overlay__products--visible',
        searchWordItemValue: '.catalog-search-overlay__searchword-value',
        searchWordItem: '.catalog-search-overlay__searchword',
    },
};

function init() {
    $(overlayConfig.selectors.searchInput).each((i, el) => {
        const $searchInput = $(el);
        initSearchInput($searchInput);
    });
}

// init search input
function initSearchInput($searchInput) {
    // search input changed event
    $searchInput[0].addEventListener('input', updateValues);
    const $searchOverlay = $(overlayConfig.selectors.searchOverlay);
    // eslint-disable-next-line no-unused-expressions
    window.addEventListener ? window.addEventListener('focus', elementSelected, true) : window.attachEvent('onfocusin', elementSelected);
    const $searchOverlayCloseButton = $searchOverlay.find(overlayConfig.selectors.closeButton);
    const $searchWordsContainer = $searchOverlay.find(overlayConfig.selectors.searchWordsContainer);

    $searchOverlayCloseButton.on('click', () => {
        hideOverlay($searchOverlay);
    });

    $('body').on('click', () => {
        hideOverlay($searchOverlay);
    });

    $searchOverlay.on('click', (e) => {
        e.stopPropagation();
    });

    function updateValues(e) {
        // hide overlay while getting elements
        hideOverlay($searchOverlay);
        // get overlay elements if query length > 1
        if (e.target.value.length > 1) {
            initOverlay(e.target.value);
        }
    }

    function initOverlay(searchTerm) {
        // init overlay
        const $searchProductsContainer = $searchOverlay.find(overlayConfig.selectors.searchProductsContainer);
        const $searchAreasContainer = $searchOverlay.find(overlayConfig.selectors.searchAreasContainer);

        const url = new URL(window.location.href);
        const catIDcheck = !isNaN(url.searchParams.get('cat')) ? url.searchParams.get('cat') : '';
        const divIDcheck = !isNaN(url.searchParams.get('div')) ? url.searchParams.get('div') : '';

        const $categoryID = catIDcheck || divIDcheck || '';

        const $searchURLparam = `&cat=${$categoryID}`;

        // create query URL
        const getSearchOverlayJsonUrl = `${$globalConfig.urls.getSearchOverlayJson}?q=${encodeURIComponent(searchTerm)}&category=${$categoryID}`;

        // get overlay elements
        jQuery.getJSON(getSearchOverlayJsonUrl, (rowData) => {
            const key = Object.keys(rowData.suggest.suggest.filteredProductNamesSuggesterDictionary)[0];
            const suggestResults = rowData.suggest.suggest.filteredProductNamesSuggesterDictionary[key].suggestions;
            const rowResults = rowData.results.grouped.content_type_s.groups;
            let productResults = [];
            let areaResults = [];
            let $showProducts = false;
            let $showAreas = false;
            let $showSearchwords = false;

            rowResults.forEach((rowResult) => {
                if (rowResult.groupValue === 'taxonomy') {
                    areaResults = rowResult.doclist.docs;
                } else if (rowResult.groupValue === 'product') {
                    productResults = rowResult.doclist.docs;
                }
            });
            const suggestions = [];
            const products = [];
            const areas = [];
            // get overlay elements -> suggestions
            if (suggestResults.length > 0) {
                suggestResults.forEach((suggestion) => {
                    suggestions.push(suggestion.term);
                });
            }
            // get overlay elements -> products
            if (productResults.length > 0) {
                productResults.forEach((product) => {
                    let cardPictureXS = $globalConfig.images.cardPictureMD;
                    let cardPictureMD = $globalConfig.images.cardPictureMD;
                    let cardPictureXL = $globalConfig.images.cardPictureMD;
                    let showImage = true;
                    if (product.document_references) {
                        product.document_references.forEach((image) => {
                            if (image.includes('WEBXS')) {
                                cardPictureXS = $globalConfig.urls.mediaFilesURL + image.split('#')[2];
                            } else {
                                showImage = false;
                            }
                            if (image.includes('WEBSM')) {
                                cardPictureMD = $globalConfig.urls.mediaFilesURL + image.split('#')[2];
                            } else {
                                showImage = false;
                            }
                            if (image.includes('WEBMD')) {
                                cardPictureXL = $globalConfig.urls.mediaFilesURL + image.split('#')[2];
                            } else {
                                showImage = false;
                            }
                        });
                    }

                    let firstCat = '';
                    if (product.product_categories_tax_ids && product.product_categories_tax_ids.length) {
                        const catArray = product.product_categories_tax_ids[0].split('#');
                        firstCat = catArray[catArray.length - 1];
                    }

                    const tempProduct = {
                        name: product.name,
                        id: product.id,
                        productID: product.productID,
                        showImage,
                        images: {
                            cardPictureXS,
                            cardPictureMD,
                            cardPictureXL,
                        },
                        firstCat,
                    };
                    products.push(tempProduct);
                });
            }
            // get overlay elements -> areas
            if (areaResults.length > 0) {
                areaResults.forEach((area) => {
                    const tempArea = {
                        name: area.name,
                        categories: area.indication_tax_names,
                        categoryIds: area.indication_tax_ids,
                        description: area.longDescription_t ? strip(area.longDescription_t).substring(0, 150) : '',
                    };
                    areas.push(tempArea);
                });
            }

            const uniqueSuggestions = unique(suggestions);
            let searchwordsContainerData = '';
            let searchProductsContainerData = '';

            // create overlay elements -> suggestions
            if (uniqueSuggestions.length > 0) {
                uniqueSuggestions.forEach((suggestion) => {
                    searchwordsContainerData += `
                    <a class="catalog-search-overlay__searchword" href="${$globalConfig.urls.searchHtml}?q=${suggestion + $searchURLparam}" title="${suggestion}">
                        <span class="catalog-search-overlay__searchword-value">${suggestion}</span>
                    </a>`;
                });
                $searchWordsContainer.text('');
                $searchWordsContainer.append(searchwordsContainerData);

                const $searchWordItem = $searchOverlay.find(overlayConfig.classNames.searchWordItem);

                $searchWordItem.on('click', (e) => {
                    e.preventDefault();
                    elementSelected(true);
                });
                $showSearchwords = true;
            } else {
                $showSearchwords = false;
                $searchWordsContainer.text($globalConfig.labels.searchOverlay.noSuggestionsMessage);
            }
            // create overlay elements -> products
            if (products.length > 0) {
                products.forEach((product) => {
                    let pictureHtml = `<div class="rfct-placeholder-image">
                        <div class="rfct-placeholder-image__ratio" style="padding-top: ${((9 / 16) * 100).toFixed(5)}%;"></div>
                        <div class="rfct-placeholder-image__small">
                            <img src="${$globalConfig.images.noImage}">
                        </div>
                    </div>`;

                    if (!product.showImage) {
                        pictureHtml = `<picture>
                            <source media="(min-width: 999px)" data-srcset="${product.images.cardPictureXS} 1x, ${product.images.cardPictureXS} 2x" srcset="${product.images.cardPictureXS} 1x, ${product.images.cardPictureXS} 2x">
                            <source media="(min-width: 797px)" data-srcset="${product.images.cardPictureXS} 1x, ${product.images.cardPictureXS} 2x" srcset="${product.images.cardPictureXS} 1x, ${product.images.cardPictureXS} 2x">
                            <source data-srcset="${product.images.cardPictureXS} 1x, ${product.images.cardPictureXS} 2x" srcset="${product.images.cardPictureXS} 1x, ${product.images.cardPictureXS} 2x">
                            <img data-srcset="${product.images.cardPictureXS}" data-object-fit="cover" src="${product.images.cardPictureXS}" alt="${product.name}" class="lazy catalog-search-overlay__area-image" />
                        </picture>`;
                    }
                    searchProductsContainerData += `
                    <div class="catalog-search-overlay__product">
                        <div class="catalog-search-overlay__product-image-container">
                            ${pictureHtml}
                        </div>
                        <a class="catalog-search-overlay__product-text-container" title="${product.name}" href="${$globalConfig.urls.productDetailPageHtml}?productID=${product.id}&cat=${product.firstCat}&etcc_cu=onsite&etcc_med_onsite=Search-OnlineCatalog-Overlay&etcc_cmp_onsite=Search-Overlay&etcc_st_onsite=${encodeURIComponent(searchTerm)}">
                        <h3 class="catalog-search-overlay__product-title catalog-search-overlay__searchword-value">${product.name}</h3>
                        <p class="catalog-search-overlay__product-code">${product.productID}</p>
                        </a>
                    </div>`;
                });
                $searchProductsContainer.text('');
                $searchProductsContainer.append(searchProductsContainerData);
                $showProducts = true;
            } else {
                $searchProductsContainer.text($globalConfig.labels.searchOverlay.noProductsMessage);
                $showProducts = false;
            }
            // create overlay elements -> areas
            let html = '';
            if (areas.length > 0) {
                areas.forEach((area) => {
                    let childHtml = '';
                    childHtml += '<div class="catalog-search-overlay__area">';
                    if (area.categories.length > 4) {
                        area.categories.forEach((category, i) => {
                            if (i === 2) {
                                childHtml += `<a href="${$globalConfig.urls.areaOfExpertiseHtml}?cat=${area.categoryIds[i]}&etcc_cu=onsite&etcc_med_onsite=Search-OnlineCatalog-Overlay&etcc_cmp_onsite=Search-Overlay&etcc_st_onsite=${encodeURIComponent(searchTerm)}" role="row" tabindex="-1">
                                    ${category}
                                </a>`;
                            } else if (i > 3) {
                                if ((area.categories.length - 1) !== i) {
                                    childHtml += `<a href="${$globalConfig.urls.categoryHtml}?cat=${area.categoryIds[i]}&etcc_cu=onsite&etcc_med_onsite=Search-OnlineCatalog-Overlay&etcc_cmp_onsite=Search-Overlay&etcc_st_onsite=${encodeURIComponent(searchTerm)}" role="row" tabindex="-1">
                                        ${category}
                                    </a>`;
                                }
                            }
                        });
                    }
                    let areaTempURL = `${$globalConfig.urls.searchHtml}?cat=${area.categoryIds[area.categoryIds.length - 1]}`;
                    if (area.categories.length === 3) {
                        areaTempURL = `${$globalConfig.urls.searchHtml}?cat=${area.categoryIds[2]}`;
                    }
                    childHtml += `
                    <a class="catalog-search-overlay__area-link" title="${area.name}" href="${areaTempURL}&etcc_cu=onsite&etcc_med_onsite=Search-OnlineCatalog-Overlay&etcc_cmp_onsite=Search-Overlay&etcc_st_onsite=${encodeURIComponent(searchTerm)}">
                        <div class="catalog-search-overlay__area-inner">
                            <div class="catalog-search-overlay__area-text-container">
                                <h3 class="catalog-search-overlay__area-title catalog-search-overlay__searchword-value">${area.name}</h3>
                            </div>
                        </div></a>`;
                    childHtml += '</div>';

                    html += `${childHtml}`;
                });

                $searchAreasContainer.text('');
                $searchAreasContainer.append(html);
                $showAreas = true;
            } else {
                $searchAreasContainer.text($globalConfig.labels.searchOverlay.noAreasMessage);
                $showAreas = false;
            }
            // show overlay when elements created
            showOverlay($searchOverlay, $showSearchwords, $showProducts, $showAreas);
        });
    }
}

// hide overlay
function hideOverlay($searchOverlay) {
    const $searchProductsAndAreasContainer = $searchOverlay.find(overlayConfig.selectors.searchProductsAndAreasContainer);
    const $searchSearchwordsContainer = $searchOverlay.find(overlayConfig.selectors.searchSearchwordsContainer);
    const $searchWordsContainerMain = $searchOverlay.find(overlayConfig.selectors.searchWordsContainerMain);
    const $searchAreasContainerMain = $searchOverlay.find(overlayConfig.selectors.searchAreasContainerMain);
    const $searchProductsContainerMain = $searchOverlay.find(overlayConfig.selectors.searchProductsContainerMain);

    $searchOverlay.removeClass(overlayConfig.classNames.searchOverlayActive);

    $searchProductsAndAreasContainer.removeClass(overlayConfig.classNames.searchContainerActive);
    $searchSearchwordsContainer.removeClass(overlayConfig.classNames.searchContainerActive);
    $searchProductsAndAreasContainer.removeClass(overlayConfig.classNames.searchContainerFullWidth);
    $searchSearchwordsContainer.removeClass(overlayConfig.classNames.searchContainerFullWidth);

    $searchWordsContainerMain.removeClass(overlayConfig.classNames.searchWordsContainerMainActive);
    $searchAreasContainerMain.removeClass(overlayConfig.classNames.searchAreasContainerMainActive);
    $searchProductsContainerMain.removeClass(overlayConfig.classNames.searchProductsContainerMainActive);
}
// show overlay
function showOverlay($searchOverlay, $showSearchwords, $showProducts, $showAreas) {
    if ($showSearchwords || $showProducts || $showAreas) {
        const $searchProductsAndAreasContainer = $searchOverlay.find(overlayConfig.selectors.searchProductsAndAreasContainer);
        const $searchSearchwordsContainer = $searchOverlay.find(overlayConfig.selectors.searchSearchwordsContainer);
        const $searchWordsContainerMain = $searchOverlay.find(overlayConfig.selectors.searchWordsContainerMain);
        const $searchAreasContainerMain = $searchOverlay.find(overlayConfig.selectors.searchAreasContainerMain);
        const $searchProductsContainerMain = $searchOverlay.find(overlayConfig.selectors.searchProductsContainerMain);

        if ($showSearchwords) {
            $searchWordsContainerMain.addClass(overlayConfig.classNames.searchWordsContainerMainActive);
            $searchSearchwordsContainer.addClass(overlayConfig.classNames.searchContainerActive);
            if (!($showProducts || $showAreas)) {
                $searchSearchwordsContainer.addClass(overlayConfig.classNames.searchContainerFullWidth);
            }
        }
        if ($showProducts) {
            $searchProductsContainerMain.addClass(overlayConfig.classNames.searchProductsContainerMainActive);
        }
        if ($showAreas) {
            $searchAreasContainerMain.addClass(overlayConfig.classNames.searchAreasContainerMainActive);
        }

        if ($showProducts || $showAreas) {
            $searchProductsAndAreasContainer.addClass(overlayConfig.classNames.searchContainerActive);
            if (!$showSearchwords) {
                $searchProductsAndAreasContainer.addClass(overlayConfig.classNames.searchContainerFullWidth);
            }
        }

        $searchOverlay.addClass(overlayConfig.classNames.searchOverlayActive);
        // eslint-disable-next-line no-undef
        const myLazyLoad = new LazyLoad();
        myLazyLoad.update();
    }
}
// make list with unique components
function unique(list) {
    const result = [];
    $.each(list, (i, e) => {
        if ($.inArray(e, result) === -1) result.push(e);
    });
    return result;
}

function strip(html) {
    const tmp = document.implementation.createHTMLDocument('New').body;
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
}

function elementSelected(clicked) {
    if ($(document.activeElement).hasClass(overlayConfig.selectors.searchWordItem) || $(document.activeElement).hasClass(overlayConfig.selectors.productItem) || $(document.activeElement).hasClass(overlayConfig.selectors.areaItem)) {
        $(overlayConfig.selectors.searchInput).val($(document.activeElement).find(overlayConfig.classNames.searchWordItemValue).html());
        if (clicked === true) {
            $(overlayConfig.selectors.searchForm).submit();
        }
    }
}

if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    init();
}
